var FCFieldsView = require('../fcFields/view');

//(for now just a field value pair like the fields */
module.exports = FCFieldsView.extend();


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/content/pages/page/docProps/view.js
 ** module id = 547
 ** module chunks = 0
 **/